import { CircularProgress } from '@mui/material';

function ProgressBar() {
  return <CircularProgress size={25} />;
}

export default ProgressBar;
